import { warn } from "@swivl-mono/helpers";
import { ActionInterface, ActionTakenType, createActionTaken } from "@swivl-mono/types";
import React from "react";

import { Config } from "../../../../Config/Config";
import { MessageHandlerInterface } from "../../../../messages/MessageHandler";
import { ListItemData } from "../../ListItem";
import "./Buttons.scss";

export interface ButtonsProps {
  item: ListItemData;
  messageHandler: MessageHandlerInterface;
  timestamp?: string;
}
export interface ButtonsState {
  isAlreadySelected: boolean;
}

export interface ButtonsItemProps {
  item: ActionInterface;
  isSelected: boolean;
  isAnItemSelected: boolean;
  itemSelected(item: ActionInterface): void;
}
export interface ButtonsItemState {
  show: boolean;
}

export class ButtonsItem extends React.Component<ButtonsItemProps, ButtonsItemState> {
  constructor(props: ButtonsItemProps) {
    super(props);
    this.state = { show: false };
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    if (!Config.canPressButtons || this.props.isSelected || this.props.isAnItemSelected) {
      return;
    }
    this.setState({ show: !this.state.show });
    this.props.itemSelected(this.props.item);
  }

  render() {
    const className =
      this.props.isSelected || !this.props.isAnItemSelected
        ? "scc-ButtonsItem swivl-primaryButton"
        : "scc-ButtonsItem swivl-primaryButton shouldHide";
    return (
      <div className={className} onClick={this.onClick}>
        {this.props.item.text}{" "}
      </div>
    );
  }
}

export class Buttons extends React.Component<ButtonsProps, ButtonsState> {
  constructor(props: ButtonsProps) {
    super(props);
    const actionTaken = this.props.item.message.actionTaken;
    this.state = { isAlreadySelected: actionTaken ? true : false };
    this.actionSelected = this.actionSelected.bind(this);
  }
  actionSelected(item: ActionInterface) {
    warn("actionSelected :", item);
    const messageId = this.props.item.message.uuid;
    const actionTaken = createActionTaken(ActionTakenType.Selected, item.id, item.data);

    this.props.messageHandler.actionTaken(messageId, actionTaken);
    // this.setState({selectTwo:true});
  }

  render() {
    const item: any = this.props.item;
    const actions: Array<ActionInterface> = item.message?.payload.actions;
    const actionTaken = this.props.item.message.actionTaken;

    let selectedActionId: string | undefined;
    if (actionTaken) {
      console.log("actionTaken :", actionTaken);

      if (actionTaken.type == ActionTakenType.Selected) {
        selectedActionId = actionTaken.target;
      }
    } else if (!item.isActive) {
      // Hide it if it is not active.
      console.log("not active, hide buttons");
      return null;
    }

    const visibleItems = actions.filter((item) => !this.state.isAlreadySelected || item.id == selectedActionId);

    const buttons = visibleItems.map((item) => {
      const isSelected = item.id == selectedActionId;
      console.log("isSelected :", isSelected);

      return (
        <ButtonsItem
          key={item.id}
          item={item}
          isSelected={isSelected}
          isAnItemSelected={selectedActionId ? true : false}
          itemSelected={this.actionSelected}
        />
      );
    });
    if (buttons.length === 0) {
      return null;
    }

    return (
      <div className="scc-Buttons">
        {buttons}
        {this.props.timestamp && <div className="body-2xs clear-both text-grey-500">{this.props.timestamp}</div>}
      </div>
    );
  }
}
